import { motion } from "framer-motion";
import { SERVICES } from "../../data/content";

export const Services = () => {
  return (
    <section id="services" data-testid="services-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="max-w-2xl mb-14">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[2px] w-10 bg-[#F5B800]" />
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1C9FD8]">What We Do</p>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-slate-900">
            Four streams, one engineering standard.
          </h2>
          <p className="mt-6 text-base lg:text-lg text-slate-600 leading-relaxed">
            From first concept to shipped firmware and trained teams — we cover the full embedded lifecycle.
          </p>
        </div>

        {/* Swiss grid borders — no gaps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-l border-slate-200">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.id}
                data-testid={`services-card-${s.id}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group border-r border-b border-slate-200 p-8 lg:p-10 hover:bg-[#F8FAFC] transition-colors"
              >
                <span className="block font-display text-sm font-bold text-slate-300 mb-8">0{i + 1}</span>
                <Icon className="w-9 h-9 text-slate-900 group-hover:text-[#1C9FD8] transition-colors mb-5" />
                <h3 className="font-display text-xl font-semibold tracking-tight text-slate-900">{s.title}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
